export const placeholderYouTubeUrls: string[] = [
    'https://www.youtube.com/watch?v=pwJPSFXhMus',
    'https://www.youtube.com/watch?v=_OvSt_TCohc',
    'https://www.youtube.com/watch?v=nAwBlCjh2CY',
    'https://www.youtube.com/watch?v=RMWYJEIYb4w',
    'https://www.youtube.com/watch?v=5AgB_1FEULc',
    'https://www.youtube.com/watch?v=C9V8e_CVTZY',
    'https://www.youtube.com/watch?v=8mSCCDwk0e0',
];